import { get } from '@/utils'

class TokenService {
  GetAll = async () => (await get(`/tokens`)).result
}
export const tokenService = new TokenService()
